// Module
var code = "<ul> <li>Access your online account</li> <li>Make online payments for you</li> <li>Request changes or adjustments to your loan account</li> </ul> ";
// Exports
export default code;